import { computed, ref, watch } from "vue";
import { useStore } from "vuex";

export default function useMapFlags() {
  const store = useStore();

  const map = ref({ file: "", filename: "" });
  const drivingRangeMap = ref({ file: "", filename: "" });
  const flag = ref({ file: "", filename: "" });
  const logo = ref({ file: "", filename: "" });
  const course = ref();
  const showAlert = ref(false);

  const loading = computed(() => store.getters["utilities/isLoading"]);
  const error = computed(() => store.getters["utilities/getErrors"]);
  const success = computed(() => store.getters["utilities/getSuccessStatus"]);

  watch(error, (newError) => {
    if (newError) {
      store.dispatch("toastNotification/displayToast", {
        message: newError,
        type: "error",
      });
    }
  });

  watch(success, (newStatus) => {
    if (newStatus) {
      map.value = { file: "", filename: "" };
      drivingRangeMap.value = { file: "", filename: "" };
      flag.value = { file: "", filename: "" };
      logo.value = { file: "", filename: "" };

      store.dispatch("toastNotification/displayToast", {
        message: "Map and Flags uploaded successfully.",
        type: "success",
      });
    }
  });

  const setShowAlert = (value) => {
    showAlert.value = value;
  };

  const isFormValid = computed(() => {
    return (
      (map.value.file ||
        drivingRangeMap.value.file ||
        flag.value.file ||
        logo.value.file) &&
      course.value?.id
    );
  });

  const onUploadClicked = async () => {
    const payload = new FormData();
    if (map.value.file) {
      payload.append("map", map.value.file);
    }
    if (drivingRangeMap.value.file) {
      payload.append("drivingRangeMap", drivingRangeMap.value.file);
    }
    if (flag.value.file) {
      payload.append("mapFlags", flag.value.file);
    }
    if (logo.value.file) {
      payload.append("logo", logo.value.file);
    }

    await store.dispatch("utilities/uploadMapAndFlags", {
      courseId: course.value.id,
      payload,
    });
  };

  return {
    map,
    drivingRangeMap,
    flag,
    logo,
    course,
    onUploadClicked,
    isFormValid,
    setShowAlert,
    showAlert,
    loading,
    success,
    error,
  };
}
